export default __webpack_public_path__ + "static/media/email-icon.db51ae43.svg";